import React from 'react';
import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { rgba, p3, media } from '../styles/stylesTheme';

const Notification = ({
    children,
    type,
    persistent,
    onClose,
}) => {
    return (
        <MotionNotificationContainer
            type={type}
            initial={{
                opacity: 0,
                y: -10,
                x: '-50%',
            }}
            animate={{
                opacity: 1,
                y: 0,
                x: '-50%',
            }}
            exit={{
                opacity: 0,
                y: -10,
                x: '-50%',
                transition: {
                    y: {
                        type: 'tween',
                        duration: 0.3,
                        ease: 'easeIn',
                    },
                    opacity: {
                        duration: 0.2,
                    },
                },
            }}
            transition={{
                y: {
                    type: 'spring',
                    bounce: 1,
                    stiffness: 300,
                    damping: 15,
                    duration: 0.3,
                },
                opacity: {
                    duration: 0.3,
                    ease: 'easeInOut',
                },
            }}
        >
            <NotificationContent>
                {children}
                {persistent && <OkButton onClick={onClose}>OK</OkButton>}
            </NotificationContent>
        </MotionNotificationContainer>
    );
};

const typeStyles = {
    success: css`
        background: ${props => rgba(props.theme, 'colorAccent', 0.96)};
        background: ${props => p3(props.theme, 'pcolorAccent', 0.96)};
        color: ${props => rgba(props.theme, 'white', 1)};
    `,
    warn: css`
        background: ${props => rgba(props.theme, 'colorAccent', 0.96)};
        background: ${props => p3(props.theme, 'pcolorAccent', 0.96)};
        color: ${props => rgba(props.theme, 'white', 1)};
    `,
    error: css`
        background: ${props => rgba(props.theme, 'colorAccent', 0.96)};
        background: ${props => p3(props.theme, 'pcolorAccent', 0.96)};
        color: ${props => rgba(props.theme, 'white', 1)};
    `,
};

const MotionNotificationContainer = styled(motion.div)`
    position: fixed;
    z-index: 2000000;
    padding: 0.7em 1.2em 0.75em;
    border-radius: 0.8em;
    box-shadow: 0px 2px 6.3px 0px rgba(0, 0, 0, 0.2);
    text-align: center;
    max-width: 32em;
    font-size: 1.2em;
    ${props => typeStyles[props.type] || typeStyles.success}

    top: 5em;
    left: 50%;
    right: auto;
    bottom: auto;

    ${media.tablet} {
        top: 5.6em;
        max-width: 90%;
        font-size: 1.4em;
        width: 66%;
    }
`;

const NotificationContent = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.8em;
`;

const OkButton = styled.button`
    background: ${({ theme }) => rgba(theme, 'white', 0.5)};
    border: none;
    border-radius: 0.5em;
    padding: 0.4em 1.2em;
    color: ${({ theme }) => rgba(theme, 'black', 1)};
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s ease;
    width: 6em;
    margin: 0.2em 0 0.5em;

    &:hover {
        background: ${({ theme }) => rgba(theme, 'white', 0.6)};
    }

    &:active {
        background: ${({ theme }) => rgba(theme, 'white', 0.5)};
    }
`;

export default Notification;
